import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';

import Image from '@nubank/www-latam-commons/components/Image/Image';

const StyledParagraph = styled(Typography)`
    font-size: 18px;
    line-height: 130%;
    letter-spacing: -1%;

    @media (width >= 768px) {
        font-size: 22px;
    }
`;

const DerechosArcoPage = () => (
  <Box
    width="100%"
    height="100%"
    paddingHorizontal={{ xs: '6x', md: '12x', lg: '16x' }}
    marginTop={{ xs: '80px', lg: '120px' }}
    marginBottom={{ xs: '80px', lg: '120px' }}
  >
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="center"
      paddingLeft={{
        xs: '0',
        xl: '8vw',
      }}
    >
      <Image
        src="contracts/derechos-arco-icon.svg"
        alt="Derechos ARCO"
        width={{
          xs: '150px',
          lg: '250px',
        }}
        height={{
          xs: '150px',
          lg: '250px',
        }}
      />
      <Typography
        variant="heading2"
        color="primary"
        marginTop="4x"
      >
        Nu
      </Typography>
      <Typography variant="heading1">Derechos ARCO</Typography>
    </Box>

    <Box
      maxWidth={{
        xs: '100%',
        md: '100%',
        lg: '1076px',
      }}
      margin={{
        xs: '32px auto',
        md: '48px auto',
        lg: '120px auto',
      }}
    >
      <StyledParagraph variant="paragraph1" marginBottom="8x">
        Los datos personales son cualquier información relacionada con una persona física
        identificada o identificable, como su nombre, dirección, número de teléfono, dirección de
        correo electrónico, número de seguridad social, edad, género, y profesión, así como toda
        aquella información que permita o contribuya a identificar a la persona.
      </StyledParagraph>

      <StyledParagraph variant="paragraph1" marginBottom="8x" strong>
        Uno de los pilares de Nu es la transparencia en que compartimos nuestros procesos, y en
        este caso el tratamiento de datos personales que forman parte de nuestra Política de
        Privacidad.
      </StyledParagraph>

      <StyledParagraph variant="paragraph1" marginBottom="8x">
        La protección de tus datos personales es un derecho vinculado a la protección de tu
        privacidad. Los
        {' '}
        <strong>derechos ARCO</strong>
        {' '}
        permiten que las personas físicas puedan
        solicitar el acceso, rectificación, cancelación u oposición de su información personal,
        con el propósito de impedir su tráfico ilícito y la potencial vulneración de los mismos.
      </StyledParagraph>

      <StyledParagraph variant="paragraph1" marginBottom="8x">
        Estos derechos también son conocidos como Derechos de Acceso, Rectificación, Cancelación
        y Oposición (Derechos ARCO), a través de los cuales los titulares tienen la facultad de
        solicitar el/la:
      </StyledParagraph>

      <Box marginLeft="4x" marginBottom="8x">
        <StyledParagraph variant="paragraph1" marginBottom="4x">
          •
          {' '}
          <StyledParagraph variant="paragraph1" strong tag="span">Acceso:</StyledParagraph>
          {' '}
          Conocer cuáles son los datos personales en posesión de Nu y
          para qué están siendo utilizados, rectificación.
        </StyledParagraph>
        <StyledParagraph variant="paragraph1" marginBottom="4x">
          •
          {' '}
          <StyledParagraph variant="paragraph1" strong tag="span">Rectificación:</StyledParagraph>
          {' '}
          Solicitar la corrección de tus datos personales cuando
          estos resulten ser inexactos o incorrectos.
        </StyledParagraph>
        <StyledParagraph variant="paragraph1" marginBottom="4x">
          •
          {' '}
          <StyledParagraph variant="paragraph1" strong tag="span">Cancelación:</StyledParagraph>
          {' '}
          Solicitar la eliminación total o parcial de los datos
          personales por considerar que su tratamiento no se está ajustando a los principios y
          deberes que prevé la normativa aplicable sobre protección de datos.
        </StyledParagraph>
        <StyledParagraph variant="paragraph1">
          •
          {' '}
          <StyledParagraph variant="paragraph1" strong tag="span">Oposición:</StyledParagraph>
          {' '}
          Oponerse al tratamiento de sus datos personales para
          finalidades específicas.
        </StyledParagraph>
      </Box>

      <StyledParagraph variant="paragraph1" marginBottom="8x">
        <StyledParagraph variant="paragraph1" strong tag="span">Revocación del consentimiento:</StyledParagraph>
        {' '}
        En cualquier momento, los titulares pueden
        comunicar su deseo de retirar su consentimiento para el tratamiento de sus datos
        personales, lo cual implica que Nu cese el tratamiento de todos los datos personales que
        posea de dicho titular, salvo que exista algún impedimento legal.
      </StyledParagraph>

      <Typography
        variant="heading3"
        marginTop={{
          xs: '16x',
          lg: '120px',
        }}
        marginBottom={{
          xs: '8x',
          lg: '16x',
        }}
      >
        ¿Cómo puedo ejercer estos derechos?
      </Typography>

      <StyledParagraph variant="paragraph1" marginBottom="8x">
        Para que tú o tu representante legal inicien el ejercicio de estos derechos te pedimos
        que nos escribas al correo
        {' '}
        <a href="mailto:misdatos@nu.com.mx" style={{ textDecoration: 'underline' }}>
          misdatos@nu.com.mx
        </a>
        {' '}
        adjuntando lo siguiente:
      </StyledParagraph>

      <Box marginLeft="4x" marginBottom="8x">
        <StyledParagraph variant="paragraph1" marginBottom="4x">
          • Tu nombre y domicilio, así como un medio para comunicarte la respuesta a tu solicitud.
        </StyledParagraph>
        <StyledParagraph variant="paragraph1" marginBottom="4x">
          • Los documentos que acrediten tu identidad o, en su caso, la representación legal de
          aquella persona que ejerza el derecho por ti.
        </StyledParagraph>
        <StyledParagraph variant="paragraph1" marginBottom="4x">
          • La descripción de los datos personales respecto de los que se busca ejercer alguno de
          los derechos antes mencionados.
        </StyledParagraph>
        <StyledParagraph variant="paragraph1">
          • Cualquier otro elemento o documento que facilite la localización de tus datos
          personales.
        </StyledParagraph>
      </Box>

      <StyledParagraph
        variant="paragraph1"
        marginBottom="8x"
        marginTop={{
          xs: '8x',
          lg: '16x',
        }}
      >
        Una vez que tú o tu representante legal envíe la información, nuestro Departamento de
        Datos Personales le dará atención y te enviará la respuesta en máximo 20 días hábiles,
        de acuerdo con lo que establece la Ley Federal de Protección de Datos Personales en
        Posesión de los Particulares (LFPDPPP).
      </StyledParagraph>

      <StyledParagraph variant="paragraph1">
        ¿Tienes más dudas respecto a Datos Personales o Derechos ARCO? puedes escribirle al
        Departamento de Datos Personales de Nu al correo
        {' '}
        <a href="mailto:misdatos@nu.com.mx" style={{ textDecoration: 'underline' }}>
          misdatos@nu.com.mx
        </a>
      </StyledParagraph>
    </Box>
  </Box>
);

export default DerechosArcoPage;
